module.exports = __webpack_public_path__ + "img/2025-03-27-02-02.7f8422f6.png";